<template>
    <el-container>
        <td-permission :permissions="permissionsView">
            <div slot="havePermission">
                <el-aside class="aside-classify-tree">
                    <td-tree
                        :lazyloading="lazyloading"
                        :draggable="draggable"
                        :isDbClick="true"
                        :calInternal="true"
                        :isClick="true"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :checkStrictly="false"
                        ref="TdTree"
                        @onDbClick="onClick"
                        @onClick="onClick"
                        :checkNodes="checkNodes"
                        :showBox="false"
                        :dragLevel="true"
                        :isPaging="true"
                        :expandOnClick="true"
                        :defaultProps="defaultProps"
                        :isDistributed="false"
                        :interfaceName="interfaceName"
                        :inputShow="inputShow"
                        :params="treeParams"
                        @nodeDrop="nodeDrop"
                    >
                    </td-tree>
                </el-aside>
            </div>
        </td-permission>
        <el-container>
            <el-header>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-row :gutter="20" class="paddingLeft10 paddingTop10">
                            <p>{{ tableName }}</p>
                        </el-row>
                    </div>
                </td-permission>
                <el-form @submit.native.prevent :inline="true" :model="fromProperty" ref="fromProperty">
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-form-item :label="$t('pgCommon.PROPERTY_NAME')" prop="sPropertyName">
                                <td-input v-model="fromProperty.sPropertyName" @keyup.enter.native="btnQuery"></td-input>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item class="paddingLeft10">
                        <td-button @click="btnQuery" :permissions="permissionsView" :loading="loading" type="primary">{{ $t('common.QUERY') }}</td-button>
                        <td-button :permissions="permissionsAdd" @click="btnAddProperty">{{ $t('pgCommon.ADD') }}</td-button>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-main>
                <td-permission :permissions="permissionsView" style="width:100%">
                    <div slot="havePermission">
                        <!-- 加载配置文件属性表格 -->
                        <td-table :columns="columns" :dataSource="tableData" :rowKey="sId" :hasPage="false" :hasMutiSelect="false" ref="tableInfo"></td-table>
                    </div>
                </td-permission>
                <dialog-property
                    v-if="dialogPropertyVisible"
                    :dialogPropertyVisible="dialogPropertyVisible"
                    :editItem="editItem"
                    :treeNode="treeNode"
                    :title="title"
                    :isAddData="isAddData"
                    @propertyDialogClose="propertyDialogClose"
                    @successQuery="successQuery"
                ></dialog-property>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import propertyApi from './assets/api.js';
import dialogProperty from './components/dialogProperty.vue';
export default {
    props: {
        treeList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        defaultProps: {
            type: Object,
            default: function() {
                return {
                    children: 'children',
                    label: 'label',
                    id: 'id',
                    imgName: 'imgName'
                };
            }
        },
        imgloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        typeContent: {
            type: Array,
            default: function() {
                return [];
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        draggable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        inputName: {
            type: String,
            default: function() {
                return 'component.PLEASE_ENTER_NAME';
            }
        },
        // 树形是否分页
        isPaging: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        height: {
            type: Number,
            default: function() {
                return 800;
            }
        }
    },
    // 初始化渲染
    components: {
        'dialog-property': dialogProperty
    },
    mounted() {
        this.btnQuery();
    },
    // 定义数据
    data() {
        return {
            permissionsView: ['configFile:view'],
            permissionsAdd: ['configFile:add'],
            permissionsDel: ['configFile:del'],
            permissionsEdit: ['configFile:edit'],
            fromProperty: {
                sPropertyName: ''
            },
            dialogPropertyVisible: false,
            tableData: [],
            tableName: '未选择',
            nowTreeItem: null, // 当前选中树形节点
            treeNode: null, //树形选中节点信息
            editItem: null, //选中行信息
            loading: false, // 按钮是否为加载状态
            columns: [
                {
                    prop: 'sPropertyName',
                    label: 'pgCommon.PROPERTY_NAME',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sPropertyValue',
                    label: 'pgCommon.PROPERTY_VALUE',
                    showOverflowTooltip: true
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit([params.row]);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.deleteProperty(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            )
                        ]);
                    }
                }
            ],
            interfaceName: { query: '/setting/fileController/findFileTree' },
            treeParams: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            }
        };
    },
    methods: {
        // 树形点击事件
        onClick(item) {
            if (item == null) {
                return;
            }
            this.nowTreeItem = item;
            if (item.type === 0) {
                let id = item.id;
                let modulePath = id.split(',');
                if (modulePath.length > 1) {
                    let modules = modulePath[0].split('.');
                    if (modules.length < 1) {
                        return;
                    }
                    let path = modules[modules.length - 1];
                    if (path != 'parent') {
                        this.tableName = this.$t('pgCommon.SETTING_CENTER') + ' > ' + item.label;
                    } else {
                        this.tableName = this.$t('pgCommon.SETTING_CENTER');
                    }
                }
                return;
            } else {
                let id = item.id;
                let filePath = [];
                if (id.indexOf('/') > -1) {
                    filePath = id.split('/');
                } else if (id.indexOf('\\') > -1) {
                    filePath = id.split('\\');
                }
                if (filePath.length > 1) {
                    let path = filePath[filePath.length - 2];
                    if (path === 'resources') {
                        this.tableName = this.$t('pgCommon.SETTING_CENTER') + ' > ' + item.label;
                    } else {
                        this.tableName = this.$t('pgCommon.SETTING_CENTER') + ' > ' + path + ' > ' + item.label;
                    }
                }
            }
            this.queryDataList();
        },

        // 查询托管表数据
        btnQuery() {
            if (this.$util.isEmpty(this.nowTreeItem)) {
                return;
            }
            if (this.nowTreeItem.type === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_FILE'), type: 'warning' });
                this.loading = false;
                return;
            }
            this.queryDataList();
        },

        // 获取查询参数
        getParam() {
            let queryVo = {};
            if (this.nowTreeItem != null && this.nowTreeItem.id != null && this.nowTreeItem.id !== '' && this.nowTreeItem.id !== undefined) {
                queryVo.sFilePath = this.nowTreeItem.id;
            }
            queryVo.sPropertyName = this.fromProperty.sPropertyName;
            return queryVo;
        },

        // 查询列表信息
        queryDataList() {
            let param = this.getParam();
            this.loading = true;
            propertyApi.queryFileInfo(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/fileController/queryFileInfo', response.data.statusMessage);
                    return;
                }
                var data = response.data.content;
                var arr = [];
                for (var i = 0; i < data.length; i++) {
                    //如果字符串中不包含目标字符会返回-1
                    if (data[i].sPropertyName.toUpperCase().indexOf(this.fromProperty.sPropertyName.toUpperCase()) >= 0) {
                        arr.push(data[i]);
                    }
                }
                this.tableData = arr;
            });
        },

        // 添加
        btnAddProperty() {
            if (this.nowTreeItem.type === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT_FILE'), type: 'warning' });
                return;
            }
            this.title = this.$t('pgCommon.ADD_PROPERTY');
            this.isAddData = true;
            this.dialogPropertyVisible = true;
            this.treeNode = this.nowTreeItem;
        },

        // 编辑
        btnExit(item) {
            if (null == item) {
                return;
            }
            this.isAddData = false;
            this.editItem = item[0];
            this.title = 'pgCommon.EDIT_PROPERTY';
            this.dialogPropertyVisible = true;
            this.treeNode = this.nowTreeItem;
        },

        // 删除属性
        deleteProperty(row) {
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {};
                    if (this.nowTreeItem != null && this.nowTreeItem.id != null && this.nowTreeItem.id !== '' && this.nowTreeItem.id !== undefined) {
                        param.sFilePath = this.nowTreeItem.id;
                    }
                    param.sPropertyName = this.fromProperty.sPropertyName;
                    if ((row.sPropertyName != null && row.sPropertyName !== '') || row.sPropertyName !== undefined) {
                        param.sPropertyName = row.sPropertyName;
                    }
                    propertyApi.deleteProperty(JSON.stringify(param), response => {
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('setting/tableController/deleteProperty', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                        // 重新查询
                        this.successQuery();
                    });
                })
                .catch(e => {});
        },

        successQuery() {
            setTimeout(this.queryDataList, 2000);
        },

        // 关闭表编辑页面
        propertyDialogClose() {
            this.dialogPropertyVisible = false;
        }
    }
};
</script>
<style></style>
